const VEHICLE_CONDITION_ENUM = {
    USED: 0,
    NEW: 1,
}

module.exports = {
    VEHICLE_CONDITION_ENUM
};